import * as React from 'react';
import { DefaultButton, PrimaryButton } from '@fluentui/react';
import { Panel } from '@fluentui/react';
import {useContext, useState} from "react";
import {DatePicker, SpinButton, Stack} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";

function AddPaymentSchedule(props) {
    const [user] = useContext(AuthContext);
    const [value, setValue] = useState(0);
    const [due, setDue] = useState(null);

    const _submit = (e) => {
        e.preventDefault();
        const dateObj = new Date(due);
        const month = dateObj.getMonth() < 9 ? '0' + (dateObj.getMonth()+1) : (dateObj.getMonth()+1);
        const formattedDate = `${dateObj.getFullYear()}-${month}-${dateObj.getDate()}`
        const data = {value: value, due: formattedDate, transactionId: props.transactionId};
        fetch('/api/payment/schedule', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddPaymentSchedule'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);

    return (
        <Panel
            isOpen={props.isOpen}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Harmonogram Płatności"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddPaymentSchedule'>
                <SpinButton
                    label={'Wartość Transzy:'}
                    labelPosition={'top'}
                    min={0}
                    step={0.01}
                    incrementButtonAriaLabel={'Increase value by 1'}
                    decrementButtonAriaLabel={'Decrease value by 1'}
                    value={value}
                    onChange={(e) => setValue(e.target.value || '')}
                />
                <DatePicker
                    label="Termin Transzy"
                    isRequired={true}
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={due}
                    onSelectDate={(e) => setDue(e || '')}
                />
            </form>
        </Panel>
    )
}

export default AddPaymentSchedule;